<template>
  <div class="row">
    <div class="col-12">
      <div class="mt-2 mb-3 border-bottom w-80">
        <h5>
          <slot name="title"></slot>
        </h5>
      </div>
      <p>
          <slot name="body"></slot>
      </p>
		</div>
  </div>
</template>

<script>
export default {
  name: 'column-header',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/rows/ColumnHeader.vue